var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Session from "Session";
import UserPropertyEndpoints from "src/shared/api/user-property/UserPropertyEndpoints";
import { parseFavoritesFromUserProperty, parseTagsConfigurationsFromUserProperty, getFavoriteProgramsFromResponse, getTagsConfigurationsFromResponse, } from "./presets-configurations";
const fetchUserPropertyPresets = (userId, clientId) => {
    return new Promise((resolve, reject) => {
        UserPropertyEndpoints.getProperties(userId)
            .then((userPropertyResponse) => {
            let favoritePrograms = [];
            const favoriteProgramsProperty = getFavoriteProgramsFromResponse(userPropertyResponse, clientId);
            const tagsConfigurationProperty = getTagsConfigurationsFromResponse(userPropertyResponse, clientId);
            if (favoriteProgramsProperty) {
                favoritePrograms = parseFavoritesFromUserProperty(favoriteProgramsProperty);
            }
            const tagsConfiguration = parseTagsConfigurationsFromUserProperty(tagsConfigurationProperty);
            resolve([favoritePrograms, tagsConfiguration]);
        })
            .fail(() => {
            reject();
        });
    });
};
const fetchPresets = () => __awaiter(void 0, void 0, void 0, function* () {
    const userId = Session.getInstance().getUserId();
    const clientId = Session.getInstance().getClientId();
    const response = yield fetchUserPropertyPresets(userId, clientId);
    return response;
});
export default fetchPresets;
